import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormControl } from '@angular/forms';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'app-formly-textarea',
  template: `
    <textarea
      pTextarea
      class="w-full"
      [rows]="rows"
      [style.min-height]="'calc(' + rows + ' * 1.5em + 1rem)'"
      [formlyAttributes]="field"
      [formControl]="control"
      variant="outlined"
      [autoResize]="props['autoResize'] ?? false"
    ></textarea>
  `,
  styles: [``],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormlyTextareaComponent extends FieldType {
  get control(): FormControl {
    return this.formControl as FormControl;
  }

  get rows(): number {
    return this.props.rows ?? 4;
  }

  get appearance(): 'filled' | 'outlined' {
    return this.props['appearance'] || 'filled';
  }

  constructor() {
    super();
  }
}
